export default "__VITE_ASSET__B9BD3jRi__"